import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosClient from "../../axios-client";
import { toast } from "react-toastify";

export const fetchPackagesInCart = createAsyncThunk(
  "order/cartDetails",
  async (userId = {}, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(`/order/cartDetails/${userId}`);
      return response.data.Data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch data",
      );
    }
  },
);
// remove cartItems from here
export const removeFromCart = createAsyncThunk(
  "order/removeFromCart",
  async (itemId, { rejectWithValue }) => {
    try {
      const response = await axiosClient.put(`/order/removeFromCart/${itemId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to remove item from cart",
      );
    }
  },
);
const initialState = {
  openPackageCartDrawer: false,
  loadingPackagesInCart: false,
  errorPackagesInCart: null,
  packagesInCart: [],
  removingFromCart: false,
  errorRemovingFromCart: null,
  removingOrderIds: [],
};

const PackageCartSlice = createSlice({
  name: "packagesInCart",
  initialState,
  reducers: {
    setOpenPackageCartDrawer: (state, action) => {
      state.openPackageCartDrawer = action.payload;
    },
    // ill pass value in  togglePackageCartDrawer
    togglePackageCartDrawer: (state) => {
      state.openPackageCartDrawer = !state.openPackageCartDrawer;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPackagesInCart.pending, (state) => {
        state.loadingPackagesInCart = true;
        state.errorPackagesInCart = null;
      })
      .addCase(fetchPackagesInCart.fulfilled, (state, action) => {
        state.loadingPackagesInCart = false;
        state.errorPackagesInCart = null;
        state.packagesInCart = action.payload;
      })
      .addCase(fetchPackagesInCart.rejected, (state, action) => {
        state.loadingPackagesInCart = false;
        state.errorPackagesInCart = action.error.message;
      })
      // builder
      .addCase(removeFromCart.pending, (state, action) => {
        // action.meta.arg = the orderId we passed to removeFromCart
        state.removingOrderIds.push(action.meta.arg);
        state.errorRemovingFromCart = null;
      })
      .addCase(removeFromCart.fulfilled, (state, action) => {
        const removedId = action.meta.arg;
        state.removingOrderIds = state.removingOrderIds.filter(
          (id) => id !== removedId,
        );
        state.errorRemovingFromCart = null;
        state.packagesInCart = state.packagesInCart.filter(
          (item) => item.orderId !== removedId,
        );
        toast.success("Item removed from cart");
      })
      .addCase(removeFromCart.rejected, (state, action) => {
        const failedId = action.meta.arg;
        state.removingOrderIds = state.removingOrderIds.filter(
          (id) => id !== failedId,
        );
        state.errorRemovingFromCart = action.error.message;
      });
  },
});

export const { setOpenPackageCartDrawer, togglePackageCartDrawer } =
  PackageCartSlice.actions;
export default PackageCartSlice.reducer;
